'use client'
import React, { useContext, useEffect, useState } from 'react'
import UserContext from 'contexts/UserContext'
import Avatar from './avatar'
import StateConfirmed from '../assets/StateConfirmed.svg'
import StatePending from '../assets/statePending.svg'
import StateRejected from '../assets/stateRejected.svg'
import { Link, useNavigate } from 'react-router-dom'
import Modif from '../assets/modif.svg'
import XRejected from '../assets/XRejected.svg'
import navigationIcon from '../assets/navigationIcon.svg'
import IconConfirmed from '../assets/iconConfirmed.svg'
import IconPending from '../assets/iconPending.svg'
import DropDown from 'assets/iconTsx/DropDown'
import ScoreIcon from '../assets/ScoreIconsRP.svg'
import Barre from '../assets/xpRewardPoint.svg'
import MedalsBronze from '../assets/MedalsBronze.png'
import MedalsSilver from '../assets/MedalsSilver.png'
import MedalsGold from '../assets/MedalsGold.png'
import MedalsPlatinum from '../assets/MedalsPlatinum.png'
type UserState = 'rejected' | 'pending' | 'confirmed' | 'KYC' | 'infoPersonnel' | 'userActive'

type GamePackType = {
  color: string;
  medals: string;
}
const RightDash: React.FC = () => {
  const { user, setUser } = useContext(UserContext)
  const navigate = useNavigate()
const getUserState = (): UserState | null => {
  if (!user?.user) return null

  if (user.user.status === 'pending' && user.user.isDocumentSent) {
    return 'pending'
  }

  if (user.user.status === 'pending' && user.user.birthDate) {
    return 'KYC'
  }

  if (user.user.status === 'pending' && !user.user.birthDate) {
    return 'infoPersonnel'
  }

  if (
    user.user.status === 'confirmed' &&
    user.user.nbTransactionsPaid > 0
  ) {
    return 'userActive'
  }

  if (
    user.user.status === 'confirmed' &&
    user.user.isDocumentSent
  ) {
    return 'confirmed'
  }

  return 'rejected'
}

const [stateUser, setStateUser] = useState<UserState | null>(null)

useEffect(() => {
  const newStateUser = getUserState()

  if (newStateUser) {
    setStateUser(newStateUser)
  }
}, [
  user?.user?.status,
  user?.user?.isDocumentSent,
  user?.user?.birthDate,
  user?.user?.nbTransactionsPaid,
])
if (!stateUser) {
  return <div>Chargement...</div>
}

  const STATE_CONFIG = {
    rejected: {
      img: StateRejected,
      bg: 'bg-[#EE443F]',
      color: 'text-[#EE443F]',
      icon: XRejected,
      msg: '',
    },
    pending: {
      img: StatePending,
      bg: 'bg-[#FFAA00]',
      color: 'text-[#FFAA00]',
      icon: IconPending,
      msg: 'Votre compte est en cours de validation',
    },
    confirmed: {
      img: StateConfirmed,
      bg: 'bg-[#43B75D]',
      color: 'text-[#43B75D]',
      icon: IconConfirmed,
      msg: `Félicitations, vous pouvez envoyer de l'argent`,
    },
    userActive: {
      img: StateConfirmed,
      bg: 'bg-[#43B75D]',
      color: 'text-[#43B75D]',
      icon: '',
      msg: (
        <p className=" lg:text-start text-center">
          Transférez, Payez, Rechargez, Assurez sans frontières... <br /> My Easy Transfer vous facilite tout !
        </p>
      ),
    },

    KYC: {
      img: StateRejected,
      bg: 'bg-[#EE443F]',
      color: 'text-[#EE443F]',
      icon: XRejected,
      msg: `Merci de valider votre identité pour pouvoir effectuer des transferts. `,
    },
    infoPersonnel: {
      img: StateRejected,
      bg: 'bg-[#EE443F]',
      icon: XRejected,
      color: 'text-[#EE443F]',
      msg: `Veuillez compléter vos informations. `,
    },
  }

  const { img, bg, msg, color, icon } = STATE_CONFIG[stateUser]

  const gamePack: Record <string, GamePackType> = {
    Bronze:{color:'#AC7F5E', medals:MedalsBronze},
    Silver:{color:'#D0D0D0', medals:MedalsSilver},
    Gold:{color:'#F3BF5F', medals:MedalsGold},
    Platinum:{color:'#B188FF', medals:MedalsPlatinum},
    
  }

  const currentMedalGame =  gamePack[user?.user?.game?.pack ?? 'Bronze'] ?? gamePack.Bronze
  const balance = user?.user?.game?.balance ?? 0
  const packBalance = user?.user?.game?.packBalance ?? 0
  const interval =
  packBalance > 0
    ? Math.min((balance / (packBalance *  Number(user?.user?.game?.packLevel))) * 100, 100)
    : 0

  return (
    <div className="flex flex-col mt-2 sm:mt-0 items-center w-full">
      <div className="flex items-center lg:items-start  font-roboto  gap-4  w-full  lg:justify-between  ">
        <div className="lg:w-[110px] sm:w-auto ">
          <div
            className={`rounded-full flex items-center justify-center h-[120px] w-[120px] lg:w-[100px] lg:h-[100px] relative ${bg}`}
          >
            <img className=" absolute left-[100px] bottom-[90px] lg:bottom-[80px] lg:left-[75px] " src={img} alt="" />
            {currentMedalGame && <img className=" absolute left-0  lg:-left-3 top-[90px] lg:top-[70px] " src={currentMedalGame.medals} alt="" />}

            <Avatar
              shadow="rounded-full shadow-[0_0_15px_rgba(0,0,0,0.3)]"
              styleCss="lg:w-[82px] lg:h-[82px]"
              genre={user?.user?.personalInfo?.gender}
              avatar={user?.user.avatar}
            />
          </div>

        </div>

        <div className="flex flex-col lg:flex-row items-center justify-between w-full  lg:items-start mt-4 sm:mt-0 ">
          <div className="text-[23px]  text-left lg:text-center font-bold text-[#5754E5] flex flex-col lg:items-start lg:mt-2 ">
            {user?.user?.personalInfo?.lastName} {user?.user?.personalInfo?.firstName}
            <div className="text-[#5754E5]/30 text-[12px]  font-inter flex ">{user?.user?.email}</div>
            {/* <img className="mt-[20px]" src={Barre} alt="" /> */}
            <div className=' relative overflow-hidden w-[110px] h-[7px] border-[1px] mt-[20px] mb-1 rounded-[20px] shadow-[0px_2px_4px_rgba(0,0,0,0.25)]'
            >
              <span className=' absolute  left-0 h-full' 
               style={{background: currentMedalGame.color,
                width: `${interval}%`
               }}/>
            </div>
            <span className={` text-[12px]`} 
            style={{color:currentMedalGame.color}}>
              {user?.user?.game?.pack}
            </span>
          </div>

          <Link to="/settingProfile/0" className="hover:cursor-pointer hidden lg:block ">
            <img width={48} height={48} src={Modif} alt="Setting Profile" />
          </Link>
        </div>
      </div>

      <div
        className={`${color}
             ${(stateUser === 'infoPersonnel' || stateUser === 'KYC') && 'bg-[#EE443F] text-white rounded-[10px] py-2 px-1 underline'}
          
             flex gap-3 lg:leading-4  text-[12px] items-center mt-[50px] lg:mt-[40px] font-medium  lg:ml-[100px] sm:ml-0  `}
      >
        {icon && <img className="w-[15px]" src={icon} alt="User account status" />}

        {stateUser === 'infoPersonnel' || stateUser === 'KYC' ? (
          <Link to="/personalinformation" className="hover:cursor-pointer">
            {' '}
            {msg} <img className="inline-block w-[12px] align-middle ml-2" src={navigationIcon} alt="navigate" />
          </Link>
        ) : (
          <p className="cursor-default text-center">{msg}</p>
        )}
      </div>

      <div
        className="w-full h-[56px] cursor-pointer mt-[20px] rounded-[8px] bg-[#FE9600]/10 flex items-center justify-between"
        onClick={() => {
          if (user?.user) {
          setUser({
            ...user,
            user: {
              ...user.user,
              game: {
                ...user.user.game,
                isOpenRecompense: false,
              },
            },
          })
        }
          navigate('/Rewards')
        }}
      >
        <div className="w-full bg-[#FE9600] h-full px-[15px] rounded-[8px] flex items-center justify-between">
          <div className="text-white font-medium text-[8px] ">
            RP points <br />
            <span className=" text-[16px] font-roboto">{user?.user?.game?.balance && user?.user?.game?.balance>0 ? user?.user?.game?.balance : 0} RP</span>
          </div>
          <DropDown styleCssImage="fill-[#FFFFFF] -rotate-90" />
        </div>
        <img className="mx-[15px]" src={ScoreIcon} width={26} height={34} alt="Rewards Store" />
      </div>
    </div>
  )
}

export default RightDash
